class Timeline {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.scrollerInput = self.elem.querySelector('[data-scroller-input]');
        self.scrollerContainer = self.elem.querySelector('[data-scroller-container]');
    }

    init() {
        let self = this;

        self.scrollerInput.oninput = function () {
            var total = self.scrollerContainer.scrollWidth - self.scrollerContainer.offsetWidth;

            self.scrollerContainer.scrollLeft = total * (this.value / 100);
        }

        self.scrollerContainer.addEventListener("scroll", function (evt) {
            var total = self.scrollerContainer.scrollWidth - self.scrollerContainer.offsetWidth;

            self.scrollerInput.value = (self.scrollerContainer.scrollLeft / total) * 100;
        })
    }
}

export default Timeline;
